import { useState, useEffect } from "react";
import { motion } from "framer-motion";
import { Link } from "react-router-dom";
import { X, ArrowRight } from "@phosphor-icons/react";
import { Button } from "@/components/ui/button";

const BACKEND_URL = process.env.REACT_APP_BACKEND_URL;

const categories = ["All", "tvet", "enterprise", "leadership", "agriculture", "technology", "healthcare"];

export default function GalleryPage() {
  const [images, setImages] = useState([]);
  const [loading, setLoading] = useState(true);
  const [selectedCategory, setSelectedCategory] = useState("All");
  const [selectedImage, setSelectedImage] = useState(null);

  useEffect(() => {
    // Always use the full default image set (includes all uploaded images)
    setImages(getDefaultImages());
    setLoading(false);
  }, []);

  const getDefaultImages = () => [
    // TVET Category
    { id: "1", title: "New TVET School – Bombo", image_url: "https://customer-assets.emergentagent.com/job_peda-enterprises/artifacts/afobkmcc_SCHOOL.png", category: "tvet", description: "The new PEDA AFRICA TVET School facility in Bombo, Luweero District" },
    { id: "2", title: "Practical Skills Training", image_url: "https://customer-assets.emergentagent.com/job_peda-enterprises/artifacts/0tfpxi02_PP.png", category: "tvet", description: "Hands-on practical skills training for youth empowerment" },
    { id: "3", title: "ICT & Digital Skills Lab", image_url: "https://customer-assets.emergentagent.com/job_peda-enterprises/artifacts/0s4xigoz_ICT.png", category: "tvet", description: "Students learning digital and ICT skills in the computer lab" },
    { id: "4", title: "Students at TVET Campus", image_url: "https://customer-assets.emergentagent.com/job_peda-enterprises/artifacts/m5g0m2r1_ph_20769_73858.jpg", category: "tvet", description: "Students at school veranda during break time" },
    { id: "5", title: "Students Collage", image_url: "https://customer-assets.emergentagent.com/job_peda-enterprises/artifacts/e070f1t8_PicFrame3.jpg", category: "tvet", description: "Students engaged in various activities – studying, farming, and school life" },
    { id: "6", title: "School Building Construction", image_url: "https://customer-assets.emergentagent.com/job_peda-enterprises/artifacts/9myrnghu_Construction-768x587.jpg", category: "tvet", description: "New classroom block under construction" },
    
    // Leadership Category
    { id: "7", title: "School Prefects Body", image_url: "https://customer-assets.emergentagent.com/job_peda-enterprises/artifacts/cnkb2n0r_prefects-body-Serere-Campus-scaled.jpg", category: "leadership", description: "Student prefects and leaders at Serere Campus" },
    
    // Agriculture Category
    { id: "8", title: "Agribusiness Training", image_url: "https://customer-assets.emergentagent.com/job_peda-enterprises/artifacts/ymbseg05_AGRIC.png", category: "agriculture", description: "Agricultural training and agribusiness development in the field" },
    { id: "9", title: "PRiDe Program – Rice Farming", image_url: "https://customer-assets.emergentagent.com/job_peda-enterprises/artifacts/djoqt4ti_PRiDe-II-Flagship-photo.jpg", category: "agriculture", description: "Women farmers harvesting rice under the PRiDe program" },
    { id: "10", title: "Passion Fruit Farmers", image_url: "https://customer-assets.emergentagent.com/job_peda-enterprises/artifacts/f4jkl5r6_ph_28265_101967.jpg", category: "agriculture", description: "Farmers harvesting passion fruits" },
    { id: "11", title: "Farmers Cooperative", image_url: "https://customer-assets.emergentagent.com/job_peda-enterprises/artifacts/e0f592gf_11.jpg", category: "agriculture", description: "Local farmers group harvesting produce" },
    { id: "12", title: "Mango Farm Visit", image_url: "https://customer-assets.emergentagent.com/job_peda-enterprises/artifacts/scoym4rc_Visit-to-a-mango-farm-1.jpg", category: "agriculture", description: "Visit to a mango farm for agribusiness learning" },
    
    // Enterprise Category
    { id: "13", title: "Youth Exhibition", image_url: "https://customer-assets.emergentagent.com/job_peda-enterprises/artifacts/lxiebqhu_55d8f7e2-761d-4c63-9839-a0652352eb5a.jpeg", category: "enterprise", description: "Youth showcasing products at exhibition" },
    { id: "14", title: "Enterprise Skills Training", image_url: "https://customer-assets.emergentagent.com/job_peda-enterprises/artifacts/v6qw6xmc_ph_28265_101967.jpg", category: "enterprise", description: "Students learning entrepreneurship skills" },

    // Technology Category
    { id: "15", title: "TVET Ecosystem in Uganda", image_url: "https://customer-assets.emergentagent.com/job_peda-enterprises/artifacts/jmjxgcls_Understanding-the-TVET-ecosystem-in-Uganda.jpg", category: "technology", description: "Understanding the TVET ecosystem in Uganda" },
    { id: "16", title: "Uganda Lead Program", image_url: "https://customer-assets.emergentagent.com/job_peda-enterprises/artifacts/wyrbn3uv_Uganda-lead-photo.jpg", category: "technology", description: "Uganda lead photo from innovation program" },
    { id: "17", title: "Cybersecurity Training", image_url: "https://customer-assets.emergentagent.com/job_peda-enterprises/artifacts/tjy2omaw_advanced-cip-cybersecurity-training-bundle-about.jpeg", category: "technology", description: "Advanced cybersecurity and ICT training programs" },
    { id: "18", title: "Functional Safety & Cyber Training", image_url: "https://customer-assets.emergentagent.com/job_peda-enterprises/artifacts/5ftjbaxb_functional-safety-training-cyber-security-kv.jpg", category: "technology", description: "Functional safety and cybersecurity professional training" },

    // Healthcare Category
    { id: "19", title: "Community Healthcare Center – Bombo", image_url: "https://customer-assets.emergentagent.com/job_peda-enterprises/artifacts/fgzorv0v_HP.png", category: "healthcare", description: "Planned Community Healthcare Center in Bombo Town – improving access to quality healthcare" },
    { id: "20", title: "Healthcare & Nursing Training", image_url: "https://customer-assets.emergentagent.com/job_peda-enterprises/artifacts/qkndwzxh_NR.png", category: "healthcare", description: "Healthcare and nursing training programs for community health workers" },

    // Enterprise Category
    { id: "21", title: "PEDA Africa Production Line", image_url: "https://customer-assets.emergentagent.com/job_peda-enterprises/artifacts/eghjahcl_PPD.png", category: "enterprise", description: "PEDA Africa manufacturing and production facilities" },
    { id: "22", title: "PEDA Branded Products", image_url: "https://customer-assets.emergentagent.com/job_peda-enterprises/artifacts/93db3xb7_ppp.png", category: "enterprise", description: "PEDA Africa branded products – liquid soap, detergent, and household items" },
  ];

  const filteredImages = selectedCategory === "All" 
    ? images 
    : images.filter(img => img.category === selectedCategory);

  return (
    <div className="pt-20">
      {/* Hero Section */}
      <section className="relative py-20 md:py-28 bg-slate-50" data-testid="gallery-hero">
        <div className="max-w-7xl mx-auto px-4 sm:px-6 lg:px-8">
          <motion.div
            initial={{ opacity: 0, y: 20 }}
            animate={{ opacity: 1, y: 0 }}
            className="text-center max-w-3xl mx-auto"
          >
            <span className="text-xs font-bold uppercase tracking-[0.2em] text-amber-600 mb-4 block">
              Our Gallery
            </span>
            <h1 className="text-4xl sm:text-5xl font-bold text-slate-900 tracking-tight mb-6">
              Impact in Pictures
            </h1>
            <p className="text-lg text-slate-600 leading-relaxed">
              Explore moments from our programs, community events, and the transformative work happening across our project areas.
            </p>
          </motion.div>
        </div>
      </section>

      {/* Category Filter */}
      <section className="py-8 bg-white border-b border-slate-100" data-testid="gallery-filters">
        <div className="max-w-7xl mx-auto px-4 sm:px-6 lg:px-8">
          <div className="flex flex-wrap items-center justify-center gap-2">
            {categories.map((category) => (
              <button
                key={category}
                onClick={() => setSelectedCategory(category)}
                className={`px-4 py-2 text-sm rounded-lg transition-colors ${
                  selectedCategory === category
                    ? "bg-green-700 text-white"
                    : "bg-slate-100 text-slate-600 hover:bg-slate-200"
                }`}
                data-testid={`filter-${category.toLowerCase()}`}
              >
                {category === "tvet" ? "TVET" : category.charAt(0).toUpperCase() + category.slice(1)}
              </button>
            ))}
          </div>
        </div>
      </section>

      {/* Gallery Grid */}
      <section className="py-20 md:py-28" data-testid="gallery-grid-section">
        <div className="max-w-7xl mx-auto px-4 sm:px-6 lg:px-8">
          {loading ? (
            <div className="text-center py-20">
              <div className="spinner mx-auto mb-4"></div>
              <p className="text-slate-600">Loading gallery...</p>
            </div>
          ) : filteredImages.length === 0 ? (
            <div className="text-center py-20">
              <p className="text-slate-600 mb-4">No images found in this category.</p>
              <Button 
                onClick={() => setSelectedCategory("All")}
                variant="outline"
                className="rounded-xl"
              >
                View All Images
              </Button>
            </div>
          ) : (
            <div className="grid grid-cols-2 md:grid-cols-3 lg:grid-cols-4 gap-4">
              {filteredImages.map((image, index) => (
                <motion.div
                  key={image.id}
                  initial={{ opacity: 0, scale: 0.9 }}
                  whileInView={{ opacity: 1, scale: 1 }}
                  viewport={{ once: true }}
                  transition={{ delay: index * 0.05 }}
                  className={`relative group cursor-pointer overflow-hidden rounded-2xl ${
                    index % 5 === 0 ? "md:col-span-2 md:row-span-2" : ""
                  }`}
                  onClick={() => setSelectedImage(image)}
                  data-testid={`gallery-image-${image.id}`}
                >
                  <div className={`aspect-square ${index % 5 === 0 ? "md:aspect-auto md:h-full" : ""}`}>
                    <img 
                      src={image.image_url} 
                      alt={image.title}
                      className="w-full h-full object-cover group-hover:scale-110 transition-transform duration-500"
                    />
                  </div>
                  <div className="absolute inset-0 bg-gradient-to-t from-slate-900/80 via-transparent to-transparent opacity-0 group-hover:opacity-100 transition-opacity duration-300">
                    <div className="absolute bottom-0 left-0 right-0 p-4">
                      <p className="text-white font-semibold">{image.title}</p>
                      <p className="text-white/70 text-sm capitalize">{image.category}</p>
                    </div>
                  </div>
                </motion.div>
              ))}
            </div>
          )}
        </div>
      </section>

      {/* Lightbox */}
      {selectedImage && (
        <div 
          className="fixed inset-0 z-50 bg-slate-900/95 flex items-center justify-center p-4"
          onClick={() => setSelectedImage(null)}
          data-testid="gallery-lightbox"
        >
          <button 
            className="absolute top-6 right-6 p-2 bg-white/10 hover:bg-white/20 rounded-full transition-colors"
            onClick={() => setSelectedImage(null)}
            aria-label="Close"
          >
            <X className="h-6 w-6 text-white" />
          </button>
          <motion.div
            initial={{ opacity: 0, scale: 0.9 }}
            animate={{ opacity: 1, scale: 1 }}
            className="max-w-4xl w-full"
            onClick={(e) => e.stopPropagation()}
          >
            <img 
              src={selectedImage.image_url} 
              alt={selectedImage.title}
              className="w-full h-auto max-h-[80vh] object-contain rounded-lg"
            />
            <div className="mt-4 text-center">
              <h3 className="text-white text-xl font-semibold">{selectedImage.title}</h3>
              {selectedImage.description && (
                <p className="text-white/70 mt-1">{selectedImage.description}</p>
              )}
            </div>
          </motion.div>
        </div>
      )}

      {/* CTA */}
      <section className="py-20 md:py-28 bg-slate-50" data-testid="gallery-cta">
        <div className="max-w-4xl mx-auto px-4 sm:px-6 lg:px-8 text-center">
          <h2 className="text-3xl md:text-4xl font-bold text-slate-900 mb-6">
            Be Part of Our Story
          </h2>
          <p className="text-lg text-slate-600 mb-8 leading-relaxed">
            Join us in creating more impactful moments. Partner with PEDA to transform communities across Africa.
          </p>
          <Button 
            asChild 
            size="lg" 
            className="bg-green-700 hover:bg-green-800 rounded-xl px-8"
            data-testid="gallery-contact-button"
          >
            <Link to="/contact">
              Get Involved <ArrowRight className="ml-2 h-4 w-4" weight="bold" />
            </Link>
          </Button>
        </div>
      </section>
    </div>
  );
}
